import React from "react";
import { AbstractTooltip as Tooltip } from "../../ToolTip/ToolTip";
import { ObjectActionsType, useObjectsDispatch, useObjectsState } from "../../../contexts/ObjectsProvider";
import { ReactComponent as PasteIcon } from "../../../assets/Paste-White.svg";

const PasteButton = ({ readonly }: { readonly?: boolean }) => {
  const { selectedObjects } = useObjectsState();
  const objectsDispatch = useObjectsDispatch();
  const disabledClassName = readonly ? "pointer-events-none" : "";
  const disabledStyle = readonly ? { backgroundColor: "var(--disabled-color)" } : {};
  return (
    <button
      className={`wysiwyg-toolbar-btn ${disabledClassName}`}
      style={disabledStyle}
      id="paste"
      onClick={() => {
        objectsDispatch({
          type: ObjectActionsType.PASTE_OBJECTS,
        });
      }}
      data-tooltip-id="Paste"
    >
      <Tooltip id="Paste" />
      <PasteIcon />
      {/* <span className="icon-paste"></span> */}
    </button>
  );
};

export default PasteButton;
